function getStatus(value: unknown): number | undefined {
  if (value && typeof value === 'object' && 'status' in value && typeof value.status === 'number') {
    return value.status;
  }
}

/**
 * Returns the HTTP status code as a number, or `undefined` if this is not
 * an HTTP error.
 */
export function getHttpStatus(error: unknown): number | undefined {
  const status = getStatus(error);
  if (status !== undefined) {
    return status;
  }

  if (error && typeof error === 'object' && 'response' in error) {
    // graphql-request exposes HTTP status as ClientError.response.status.
    return getStatus(error.response);
  }
}
